import { css } from '@emotion/react'
import { FC } from 'react'

const IconCancel: FC = () => {
  return (
    <div css={wrapperStyle}>
      <span className='icon-cross'></span>
      <span css={hiddenStyle}>Cancel</span>
    </div>
  )
}

export default IconCancel

const wrapperStyle = css`
  margin: 0;
  border: 0;
  padding: 0;
  background: #000;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  .icon-cross {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    position: relative;
    width: 10px;
    height: 10px;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      right: 0;
      height: 2px;
      background: #fff;
      border-radius: 2px;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }

  span {
    display: block;
  }
`

const hiddenStyle = css`
  position: absolute !important;
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
`
